/*
This script continuously loads posts as the user scrolls the page. It uses the
IntersectionObserver API to detect when the last post is in view. When the last
post is in view, it fetches the next page and appends the posts to the feed.

Importantly, for this script to work, it requires that each card have the `post`
class and that the card container have the `gh-postfeed` class.
*/

let link = document.querySelector('link[rel="next"]')?.getAttribute('href');
let isLoading = false;

// Fetch and parse next page
async function getNextPage(url) {
    const res = await fetch(url);

    if (!res.ok) {
        throw new Error('Failed to fetch page');
    }

    const nextPageHtml = await res.text();
    const parser = new DOMParser();
    const parsed = parser.parseFromString(nextPageHtml, 'text/html');
    const posts = parsed.querySelectorAll('.post');
    const nextLink = parsed.querySelector('link[rel="next"]')?.getAttribute('href');

    return { posts, nextLink };
}

function getLastPost() {
    const feed = document.querySelector('.gh-postfeed');
    if (!feed) return null;
    const posts = feed.querySelectorAll('.post');
    return posts.length ? posts[posts.length - 1] : null;
}

export default function infiniteScroll() {

    if (!link) { return; }

    const feed = document.querySelector('.gh-postfeed');
    if (!feed) { return; }

    const options = {
        rootMargin: '150px',
    };

    const callback = async (entries, observer) => {
        for (const entry of entries) {
            if (!entry.isIntersecting || isLoading || !link) continue;

            isLoading = true;
            observer.unobserve(entry.target);

            try {
                const { posts, nextLink } = await getNextPage(link);

                posts.forEach(post => feed.append(post));

                if (nextLink) {
                    link = nextLink;
                    const lastPost = getLastPost();
                    if (lastPost) observer.observe(lastPost);
                } else {
                    link = null;
                    observer.disconnect();
                }
            } catch (error) {
                console.error('Infinite scroll error:', error);
            } finally {
                isLoading = false;
            }
        }
    };

    const observer = new IntersectionObserver(callback, options);

    const lastPost = getLastPost();
    if (lastPost) observer.observe(lastPost);
}